<template>
  <div class="col-12 connections">
    <div class="card finances">
      <div class="card-header">
        <h5 class="card-title mb-0">Финансы</h5>
      </div>

      <div class="d-flex navs">
        <ul class="nav nav-tabs">
          <li>
            <a
              class="active grey-button"
              id="analyzesmall-tab"
              data-bs-toggle="tab"
              href="#tab-analyzesmall"
              role="tab"
              aria-controls="tab-analyzesmall"
              aria-selected="true"
              >Анализ</a
            >
          </li>
          <li class="ms-md-4">
            <a
              class="grey-button"
              id="report-tab"
              data-bs-toggle="tab"
              href="#tab-report"
              role="tab"
              aria-controls="tab-report"
              aria-selected="false"
              >Бухгалтерская отчетность</a
            >
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="tab-content" id="myTabContent">
          <!-- Первый таб -->
          <div
            class="tab-pane fade show active"
            id="tab-analyzesmall"
            role="tabpanel"
            aria-labelledby="analyzesmall-tab"
            v-if="html || finances"
          >
            <div class="row mt-4">
              <div class="col-md-5">
                <ul class="info-list">
                  <li
                    v-for="(factor, index) in factors"
                    :key="index"
                    class="d-flex flex-row border-bottom align-items-center pt-4 justify-content-between"
                  >
                    <span class="info-value w-auto">{{ factor.title }}</span>
                    <span class="info-bold">{{ factor.text }}</span>
                  </li>
                </ul>
              </div>
              <div class="col-md-5">
                <BarChart
                  :chartData="chartDataFinances"
                  :chartOptions="chartOptions"
                />
              </div>
            </div>
            <table
              class="table table-bordered"
              style="border: 1px solid #efefef"
            >
              <template v-for="(factor, index) in financeFactors" :key="index">
                <thead v-if="factor.title">
                  <tr>
                    <th style="background-color: #f7f9fc">
                      {{ factor.title }}
                    </th>
                  </tr>
                </thead>
                <tbody v-else>
                  <tr>
                    <td>
                      {{ factor.text }}
                    </td>
                    <td>{{ factor.description }}</td>
                  </tr>
                </tbody>
              </template>
            </table>
          </div>

          <!-- Второй таб -->
          <div
            class="tab-pane fade"
            id="tab-report"
            role="tabpanel"
            aria-labelledby="report-tab"
          >
            <!-- Фильтр и кнопка "Скачать" -->
            <div
              class="card d-flex flex-row justify-content-between align-items-center col-10 px-4 py-4 mt-4"
              v-if="finances.links && finances.links['Отчет']"
            >
              <p class="mb-0">Бухгалтерская отчетность</p>
              <a
                :href="finances.links['Отчет']['2023']"
                class="btn-primary btn-small"
                target="_blank"
                >Скачать</a
              >
            </div>

            <!-- Бухгалтерский баланс -->
            <h5 class="finances-title mt-4 pt-4 pb-2">Бухгалтерский баланс</h5>
            <div class="card mt-4 inner-card">
              <div class="card-body">
                <div class="row">
                  <div class="col-6">
                    <!-- <BarChart /> -->
                  </div>
                </div>
                <div class="table-container">
                  <table class="table table-bordered colored">
                    <thead>
                      <tr>
                        <th scope="col" class="text-center">Код</th>
                        <th
                          scope="col"
                          class="text-center"
                          v-for="year in years"
                          :key="year"
                        >
                          {{ year }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="code in codes" :key="code">
                        <td>{{ code }}</td>
                        <td v-for="year in years" :key="year">
                          {{ getSumOtch(year, code) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, computed, onMounted, watch } from "vue";
import BarChart from "./cards/Diagrams/BarChart.vue";

// helper: из html_checko -> { finances_years: [{year, amount:[number]}] }
function parseHtmlToFinances(html, code = "2110") {
  if (!html) return { finances_years: [] };

  // 1) labels
  const mLabels = html.match(
    /\b(?:var|let|const)\s+labels\s*=\s*\[([\s\S]*?)\]\s*;?/m
  );
  const labels = (mLabels?.[1] || "")
    .split(",")
    .map((s) => s.trim().replace(/^['"]|['"]$/g, ""))
    .filter(Boolean);

  // 2) series для нужного code (например '2110' — выручка, '2400' — прибыль)
  const esc = (str) => String(str).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const codeEsc = esc(code);

  const blockRe = new RegExp(
    [
      "\\bif\\s*\\(\\s*code\\s*(?:==|===)\\s*['\"]",
      codeEsc,
      "['\"]\\s*\\)\\s*",
      "(?:\\{[\\s\\S]*?)?",
      "\\b(?:var\\s+|let\\s+|const\\s+)?series\\s*=\\s*\\[\\[([\\s\\S]*?)\\]\\]\\s*;?",
    ].join(""),
    "m"
  );
  const block = html.match(blockRe)?.[1] || "";

  // 3) вытянуть value
  const itemRe = /\bvalue\s*:\s*(['"])(.*?)\1/g;
  const values = [];
  let p;
  while ((p = itemRe.exec(block)) !== null) {
    const raw = p[2] || "0";
    const num = Number(String(raw).replace(/\s/g, "")) || 0;
    values.push(num);
  }

  // 4) собрать под формат LineChart: amount — массив (твой код суммирует amount[])
  const years = labels.map((year, i) => ({
    year,
    amount: [values[i] ?? 0],
  }));

  return { finances_years: years };
}
// HTML -> { years: string[], codes: string[], matrix: { [year]: { [code]: number } } }
function parseHtmlFinanceMatrix(html) {
  const result = { years: [], codes: [], matrix: {} };
  if (!html) return result;

  // labels: ['2017','2018',...]
  const mLabels = html.match(/var\s+labels\s*=\s*\[([\s\S]*?)\];/);
  const years = (mLabels?.[1] || "")
    .split(",")
    .map((s) => s.replace(/['"\s]/g, ""))
    .filter(Boolean);
  result.years = years;
  years.forEach((y) => (result.matrix[y] = {}));

  // if (code == 'XXXX') { var series = [[ { value:'...' }, ... ]] }
  const blockRe =
    /if\s*\(code\s*==\s*['"](\d{3,4})['"]\)[\s\S]*?\{\s*var\s+series\s*=\s*\[\[([\s\S]*?)\]\]\s*\}/g;

  const codesSet = new Set();
  let m;
  while ((m = blockRe.exec(html)) !== null) {
    const code = m[1];
    codesSet.add(code);

    const itemsRaw = m[2];
    const itemRe = /\{[^}]*value\s*:\s*'([^']+)'[^}]*\}/g;

    const values = [];
    let p;
    while ((p = itemRe.exec(itemsRaw)) !== null) {
      values.push(Number((p[1] || "0").replace(/\s/g, "")) || 0);
    }
    years.forEach((y, i) => {
      result.matrix[y][code] = values[i] ?? 0;
    });
  }

  result.codes = Array.from(codesSet).sort();
  return result;
}

export default defineComponent({
  name: "Finances",
  props: {
    html: String,
    finances: Object,
  },
  components: {
    BarChart,
  },
  setup(props) {
    const isOpen = ref(null);
    const chartDataFinances = ref({ labels: [], datasets: [] });
    const parsedMatrix = ref({ years: [], codes: [], matrix: {} });

    // Опции для графика
    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
          // position: "top",
        },
        title: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              return context.dataset.label + ": " + context.parsed.y;
            },
          },
        },
      },
      layout: {
        padding: {
          top: 20,
          bottom: 20,
          left: 20,
          right: 20,
        },
      },
      scales: {
        x: {
          title: {
            display: true,
          },
        },
        y: {
          display: true,
          grid: {
            display: true,
          },
          title: {
            display: false,
          },
          ticks: {
            display: false,
          },
        },
        r: {
          ticks: {
            callback: function () {
              return null;
            },
          },
        },
      },
    };
    const isCollapsed = ref(true);
    const factors = ref([]);
    const financeFactors = ref([]);

    const years = computed(() => {
      const y = parsedMatrix.value.years;
      if (y && y.length) return y;
      return Object.keys(props.finances?.additional_finances ?? {});
    });

    const codes = computed(() => {
      const c = parsedMatrix.value.codes;
      if (c && c.length) return c;

      const src = props.finances?.additional_finances ?? {};
      const set = new Set();
      Object.values(src).forEach((yearData) => {
        Object.keys(yearData ?? {}).forEach((code) => set.add(code));
      });
      return Array.from(set).sort();
    });

    const getSumOtch = (year, code) => {
      // 1) сначала из HTML-матрицы
      const v = parsedMatrix.value.matrix?.[year]?.[code];
      if (v !== undefined) return formatPrice(v);

      // 2) fallback к старым данным
      return formatPrice(
        props.finances?.additional_finances?.[year]?.[code]?.СумОтч
      );
    };

    function toggleCollapse() {
      isCollapsed.value = !isCollapsed.value;
    }

    const formatPrice = (price) => {
      if (price === null || price === undefined) {
        return "—";
      }
      return new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(price);
    };

    const getParsing = () => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(props.html, "text/html");
      const finances = doc.getElementById("finances");

      if (finances) {
        const table = finances.querySelector("table");
        const table1 = finances.querySelectorAll("table")[1];
        const tr = table?.querySelectorAll("tr");
        const tr1 = table1?.querySelectorAll("tr");

        if (tr?.length) {
          tr?.forEach((stroke, index) => {
            const tdFirst = stroke.querySelector("td:nth-child(1)");
            const tdSecond = stroke.querySelector("td:nth-child(2) span");
            if (tdFirst?.textContent && tdFirst?.textContent !== "Активы") {
              const tableItemObject = {
                id: index + 1,
                title: tdFirst?.textContent || null,
                text: tdSecond?.textContent || null,
              };
              factors.value.push(tableItemObject);
            }
          });

          if (tr1?.length) {
            tr1?.forEach((stroke, index) => {
              const th = stroke.querySelector("th");
              const tdFirst = stroke.querySelector("td:nth-child(1)");
              const tdSecond = stroke.querySelector("td:nth-child(2) span");
              const tableItemObject = {
                id: index + 1,
                title: th?.textContent || null,
                text: tdFirst?.textContent.replace(/\?/g, "") || null,
                description: tdSecond?.textContent || null,
              };
              financeFactors.value.push(tableItemObject);
            });
          }
        }
      }
    };

    const hydrate = () => {
      if (!props.html) return;

      // 1) парсим HTML → получаем { finances_years }
      const parsed = parseHtmlToFinances(props.html, "2110"); // '2110' — выручка. Нужна прибыль — поставь '2400'

      // 2) собираем labels + data под BarChart
      const labels = parsed.finances_years.map((x) => x.year);
      const data = parsed.finances_years.map((x) =>
        (x.amount ?? []).reduce((s, n) => s + Number(n || 0), 0)
      );

      // 3) кладём в chartDataFinances в нужном формате
      chartDataFinances.value = {
        labels,
        datasets: [
          {
            label: "Выручка (2110)",
            data,
            backgroundColor: "#86C2FF4D",
            borderColor: "#86C2FF",
            borderWidth: 1,
            borderRadius: 5,
            barPercentage: 1,
            categoryPercentage: 0.8,
          },
        ],
      };

      parsedMatrix.value = parseHtmlFinanceMatrix(props.html);

      // дальше твой парсинг факторов
      factors.value = [];
      financeFactors.value = [];
      getParsing();
    };

    onMounted(hydrate);
    watch(() => [props.html, props.finances], hydrate, { deep: true });

    return {
      isOpen,
      chartOptions,
      factors,
      financeFactors,
      years,
      codes,
      chartDataFinances,
      getSumOtch,
      formatPrice,
      toggleCollapse,
    };
  },
});
</script>

<style scoped lang="scss">
.table-container {
  width: 100%;
  height: 500px;
  overflow-x: auto;
  overflow-y: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  // min-width: 1000px;

  th {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #fff !important;
  }
}
</style>
